import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private _router: Router) { }

  canActivate(_route?: ActivatedRouteSnapshot) {
    const isLoggedIn: boolean = this.authService.isLoggedIn();

    /* istanbul ignore if */
    if (!isLoggedIn) {
      this._router.navigate(['login']);

      return false;
    }

    return true;
  }

}
